import useLocalStorage from "use-local-storage";
import type { SortDirection } from "../components/UI/Table";

export interface TableSort<K extends string> {
  key: K;
  direction: SortDirection;
}

export default function useTableSort<K extends string>(storageKey: string) {
  const [sort, setSort] = useLocalStorage<TableSort<K> | null>(
    storageKey,
    null,
  );

  function toggleSort(key: K) {
    setSort((prev) =>
      prev?.key !== key
        ? { key, direction: "asc" }
        : prev.direction === "asc"
        ? { key, direction: "desc" }
        : null,
    );
  }

  function directionFor(key: K): SortDirection | null {
    return sort?.key === key ? sort.direction : null;
  }

  return { sort, toggleSort, directionFor };
}
